import { ITransactFormValues } from '@tassat/forms/src/TransactForm/types';
import { Asset } from '@tassat/fred-definitions';
import { AccountBalancesStatsParam } from '@tassat/fred-extended-definitions';

import { TransactPayment } from './transactPayment';

export interface ITransactPaymentProps {
    title: string;
    transactionValues: ITransactFormValues;
    setTransactionValues: (values?: ITransactFormValues) => void;
    handleTransact: (transactValues: ITransactFormValues) => void;
    goBack: (event?: any) => void;
    accountPositionBalance: AccountBalancesStatsParam;
    allAssets: Asset[];
}

export default TransactPayment;